import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray, FormBuilder } from '@angular/forms';
import { DataService } from '../data.service';
import { Html5Qrcode, Html5QrcodeScanner } from 'html5-qrcode'
import { Router } from '@angular/router';

@Component({
  selector: 'app-valida-qr',
  templateUrl: './valida-qr.component.html',
  styleUrls: ['./valida-qr.component.css']
})
export class ValidaQrComponent implements OnInit {
  videoElem:any;
  camaraIniciada:boolean = false;
  existeCamara:boolean = false;
  qrScanner:any;
  conexDB:boolean = true;
  QRdecodificado:boolean=false;
  esQRticket:boolean = false;
  okFolio:boolean = false;
  okFecha:boolean = false;
  okHora: boolean = false;
  okDB: boolean = false;
  msg:string = "";
  mensaje:string = "";
  t:string = "-";
  f:number = -1;
  ff:number = -1;
  fec:string = "";
  h: string = "";
  idUbi:number = 1;
  tipo:string="";
  desc:string="";

  tiempoMostrando:number=3990;
  html5QrCode:any;
  camID:string="";
  hist:any=[];
  conteo:any=[];
  validaFolio:any=[];
  entradaUbi:any=[];
  ubicacion:any=[];
  errMsg:any;
  auxMsg:string="";
  ocultaUltimos:boolean=true;

  thisForm = new FormGroup({
    ubi: new FormControl(this.idUbi, [Validators.required]),
  })

  //--> ********** USAR HTTPS (SSL) para que funcionen las cámaras!!  ********** <--//
  //--> En chrome se puede activar la bandera "insecure origens treated as secure":  chrome://flags > Habilitar y colocar sitio en el cuadro de texto

  constructor(private dataService: DataService, private router:Router) {
    localStorage.removeItem("csiBILL_QRhist");
    if(localStorage.getItem("csiBILL_QRhist")){
      this.hist = JSON.parse(localStorage.getItem("csiBILL_QRhist"));
    }
  }

  async fnHTMLDevices(){
    var devices = await navigator.mediaDevices.enumerateDevices();
    console.log(devices);
    this.auxMsg = devices.length.toString();
  }

  ngOnInit() {
    this.dataService.getVars("T-QR").subscribe(
                  rows => {   
                          this.tiempoMostrando = <any>rows
                          },          
                  error => this.errMsg = <any>error,
                  () => this.fnTiempoMostrando_Obtenido());
    this.dataService.getUbicaciones().subscribe(
                    rows => {   
                            this.ubicacion = <any>rows
                            },          
                    error => this.errMsg = <any>error,
                    () => this.fnUbicaiconesbtenidas());

    this.html5QrCode = new Html5Qrcode(/* element id */ "reader")
    Html5Qrcode.getCameras().then(devices => {
      /**
       * devices would be an array of objects of type:
       * { id: "id", label: "label" }
       */
      if (devices && devices.length) {
        this.camID = devices[0].id;
        console.log(devices);
        for (var d = 0; d < devices.length; d++){
          //this.auxMsg += "\n ... " + devices[d].id + " -# " + devices[d].label;
          if(devices[d].label.indexOf("facing back") > 0)
            this.camID = devices[d].id;
        }
        this.existeCamara = true;
        this.hist.push({"fec":this.dataService.fnGetHoy(),
                        "h":this.dataService.fnGetAhora(),
                        "u":this.idUbi,
                        "ev":"INIT VALIDA QR",
                        "t":"INI",
                        "f":-1,
                        "ff":-1
                       })
        if (this.conexDB){
          this.dataService.insEntradaUbi(this.dataService.fnGetHoy(), this.dataService.fnGetAhora(), this.idUbi, "INIT VALIDA QR", "INIT", -1, -1, -1).subscribe(
                            rows => {   
                                    this.entradaUbi = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnEntradaUbiRegistrada());
        }
        else{
          localStorage.setItem("csiBILL_QRhist", JSON.stringify(this.hist));                       
        }
        this.fnIniciar();
      }
    }).catch(err => {
      console.log("no se encontró camara")
      this.hist.push({"fec":this.dataService.fnGetHoy(),
            "h":this.dataService.fnGetAhora(),
            "u":this.idUbi,
            "ev":"CAMARA NO ENCONTRADA",
            "t":"SIN",
            "f":-1,
            "ff":-1
          })
      if (this.conexDB){
        this.dataService.insEntradaUbi(this.dataService.fnGetHoy(), this.dataService.fnGetAhora(), this.idUbi, "CAMARA NO ENCONTRADA", "SIN", -1, -1, -1).subscribe(
                rows => {   
                        this.entradaUbi = <any>rows
                        },          
                error => this.errMsg = <any>error,
                () => this.fnEntradaUbiRegistrada());
      }
      else{
        localStorage.setItem("csiBILL_QRhist", JSON.stringify(this.hist));                       
      }
    });
  }

  fnTiempoMostrando_Obtenido(){
    console.log(this.tiempoMostrando);
  }

  fnUbicaiconesbtenidas(){
    //console.log(this.ubicacion);
    if(this.ubicacion.length>0){
      this.idUbi=this.ubicacion[0].id;
      console.log("idUbi: " + this.idUbi)
    }
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    console.log(tipo);
    console.log("onClick: " + idEl);
    console.log(item);
    if(tipo=="UBI"){
      this.idUbi = idEl;
    }
  }

  fnIniciar(){
    this.msg="";
    this.QRdecodificado=false;
    this.esQRticket=false;
    this.camaraIniciada = true;  
    this.f=-1;
    this.ff=-1;
    this.fec="";
    this.h="";
    this.tipo = "";
    this.desc = "";
    
    this.html5QrCode.start(
      this.camID, 
      {
        fps: 10,    // Optional, frame per seconds for qr code scanning
        qrbox: { width: 150, height: 150 }  // Optional, if you want bounded box UI
      },
      (decodedText, decodedResult) => {
        // do something when code is read
        this.fnQRDecodificado(decodedResult);
      },
      (errorMessage) => {
        // parse error, ignore it.
      })
    .catch((err) => {
      // Start failed, handle it.
      console.log("FALLA")
    });
  }

  fnDetener(){
    this.html5QrCode.stop().then((ignore) => {
      // QR Code scanning is stopped.
    }).catch((err) => {
      // Stop failed, handle it.
    });
    this.camaraIniciada = false;
  }

  fnQRDecodificado(result: any){
    //console.log('decoded qr code:', result)
    this.QRdecodificado=true;
    this.fnDetener();
    this.esQRticket = this.fnValidaCadenaQR(result.decodedText);
    
    if(this.esQRticket){
      //console.log("esTicket");
      if(this.conexDB){   //--> VALIDAR MEDIANTE BASE DE DATOS:                
        this.dataService.validaFolio(this.f, this.ff, this.t, this.fec, this.h, this.idUbi).subscribe(
          rows => {   
                  this.validaFolio = <any>rows
                  },          
          error => this.errMsg = <any>error,
          () => this.fnFolioValidadoDB());
      }
      else{   //--> USANDO SIN CONEXIÓN A LA BASE DE DATOS (LOCALSTORAGE):
        if(this.msg.length > 0){
          this.mensaje = "FOLIO: " + this.f.toString() + " (Fecha distinta " + this.fec + ")"; 
          this.hist.push({"fec":this.dataService.fnGetHoy(),
                          "h":this.dataService.fnGetAhora(),
                          "u":this.idUbi,
                          "ev":"FOLIO (OTRA FECHA)",
                          "t":this.t,
                          "f":this.f,
                          "ff":this.ff
                          })
            localStorage.setItem("csiBILL_QRhist", JSON.stringify(this.hist));
        }
        else{
          this.mensaje = "FOLIO: " + this.f.toString();
          var auxh = this.dataService.fnGetAhora()
          this.hist.push({"fec":this.dataService.fnGetHoy(),
                          "h":auxh,
                          "u":this.idUbi,
                          "ev":"FOLIO VÁLIDO",
                          "t":this.t,
                          "f":this.f,
                          "ff":this.ff
                          })
            localStorage.setItem("csiBILL_QRhist", JSON.stringify(this.hist));
        }  
      }
    }
    else{
      this.mensaje = this.msg;
      var auxh = this.dataService.fnGetAhora()
      this.hist.push({"fec":this.dataService.fnGetHoy(),
                      "h":auxh,
                      "u":this.idUbi,
                      "ev":"QR NO VÁLIDO",
                      "t":"ERR",
                      "f":-1,
                      "ff":-1
                      })
      if(this.conexDB){
        this.dataService.insEntradaUbi(this.dataService.fnGetHoy(), auxh, this.idUbi, "QR NO VÁLIDO", "NO VAL", -1, -1, -1).subscribe(
                          rows => {   
                                  this.entradaUbi = <any>rows
                                  },          
                          error => this.errMsg = <any>error,
                          () => this.fnEntradaUbiRegistrada());
      }
      else{         
        //--> USANDO SIN CONEXIÓN A LA BASE DE DATOS (LOCALSTORAGE):    
        localStorage.setItem("csiBILL_QRhist", this.hist);
      }
    }

    setTimeout(() => {    
      this.fnIniciar();
    }, this.tiempoMostrando);

  }

  fnFolioValidadoDB(){
    var encontradoEnDB = false;
    //console.log(this.validaFolio);
    var auxh = this.dataService.fnGetAhora()
    var auxev = "";
    if(this.validaFolio.length>0){
      if(this.validaFolio[0].id > 0){
        encontradoEnDB = true;
        this.tipo = this.validaFolio[0].tipo;
        this.desc = this.validaFolio[0].des;
        //console.log(this.validaFolio[0]);
        if(this.validaFolio[0].valFec == 'OK' && this.validaFolio[0].valHora == 'OK'){
          //--> VALIDAR PRIMER ENTRADA AL RECINTO (IdUbi == 1 -> TORNIQUETES)
          if(this.validaFolio[0].advertencia == 'OK' && this.idUbi==1 && this.validaFolio[0].valYaEntro != '0'){
            this.validaFolio[0].advertencia = "ERR-ENTRADA";
          }
          //--> OK!
          if(this.validaFolio[0].advertencia == 'OK'){
            this.mensaje = "FOLIO: " + this.f.toString();
            auxev = "FOLIO";
          }
          else{
            if(this.validaFolio[0].advertencia != "ERR-ENTRADA"){   //--> FECHA ANTERIOR
              this.mensaje = "FOLIO: " + this.f.toString() + " (Fecha distinta " + this.fec + ")"; 
              auxev = "OTRA FECHA"
            }
            else{   //--> YA ACCESO HOY (U EN OTRA FECHA)
              this.msg = "Folio utilizado anteriormente";
              this.mensaje = "FOLIO: " + this.f.toString() + " (Folio utilizado anteriormente)"; 
              auxev = "YA ACCESÓ"
            }
          }
          this.hist.push({"fec":this.dataService.fnGetHoy(),
                          "h":auxh,
                          "u":this.idUbi,
                          "ev":auxev  ,
                          "t":this.t,
                          "f":this.f,
                          "ff":this.ff
                          })
          this.dataService.insEntradaUbi(this.dataService.fnGetHoy(), auxh, this.idUbi, this.mensaje, auxev != "FOLIO" ? this.fec : "OK", this.validaFolio[0].id, this.f, this.ff).subscribe(
                            rows => {   
                                    this.entradaUbi = <any>rows
                                    },          
                            error => this.errMsg = <any>error,
                            () => this.fnEntradaUbiRegistrada());
        }
        else{
          //--> FECHA / HORA NO VÁLIDA
          console.log("else 1")
        }
      }
      else{
        //--> NO ENCONTRO FOLIO
        console.log("else 2")
      }
    }
    else{
      //--> NO ENCONTRO FOLIO
      console.log("else 3")
    }
    if(!encontradoEnDB){
      this.mensaje = "FOLIO NO ENCONTRADO EN SISTEMA"; 
      this.hist.push({"fec":this.dataService.fnGetHoy(),
                      "h":auxh,
                      "u":this.idUbi,
                      "ev":"NO VÁLIDO",
                      "t":this.t,
                      "f":this.f,
                      "ff":this.ff
                      })
      this.dataService.insEntradaUbi(this.dataService.fnGetHoy(), auxh, this.idUbi, this.mensaje, 'NO SYS', this.fec,  this.f, -1).subscribe(
                        rows => {   
                                this.entradaUbi = <any>rows
                                },          
                        error => this.errMsg = <any>error,
                        () => this.fnEntradaUbiRegistrada());
    }
  }

  fnEntradaUbiRegistrada(){
    console.log(this.entradaUbi);
  }

  fnValidaCadenaQR(result:any){
    //console.log(result);
    var regresa = false;
    var pre = result.substr(0, result.indexOf("|"));
    var aux = result.substr(pre.length + 1);
    //console.log("aux: " + aux);
    this.fec = aux.substr(0, aux.indexOf("|"));
    this.h = aux.substr(this.fec.length + 1);
    //console.log(pre);
    //console.log(this.fec);
    //console.log(this.h);
    if(pre.substr(0,1) == "F")
      this.t = "F";
    if(pre.substr(0,1) == "G")
    this.t = "G";
    if(this.t == "F" || this.t == "G"){
      if(this.t=="F"){
        this.f=pre.substr(1);
      }
      if(this.t=="G"){
        this.f=pre.substr(1,pre.indexOf(">")-1);
        this.ff=pre.substring(pre.indexOf(">")+1);
        //console.log(this.f);
        //console.log(this.ff);
      }
      if(this.f > 0 && this.fec.length == 10 && this.h.length == 8){
        if(this.dataService.fnGetDateFormat(this.dataService.fnGetHoy(), "D/M/Y") != this.fec){
          this.msg = "El ticket es de otra fecha";
        }
        regresa = true
      }
      else{
        this.msg = "QR no válido";
        regresa = false;
      }
    }
    else{
      this.msg = "QR no válido";
      regresa = false;
    }
    //console.log(regresa)
    return regresa;
  }

  fnConteoOffLine(h:any, folio:any){
    var aux = [];
    for(var i = 0; i < this.hist.length; i++){
      if(this.hist[i].t == "F")
        aux.push({
                  "fec":this.hist[i].fec,
                  "h":this.hist[i].h,
                  "u":this.hist[i].u,
                  "f":parseInt(this.hist[i].f)
                 })
      if(this.hist[i].t == "G"){
        for(var j = parseInt(this.hist[i].f); j <= parseInt(this.hist[i].ff); j++){
          var auxf = j;
          aux.push({
                    "fec":this.hist[i].fec,
                    "h":this.hist[i].h,
                    "u":this.hist[i].u,
                    "f":j
                  })
        }
      }
    }
    //console.log(aux);
    if(aux.length > 0){
      this.conteo = aux.reduce((acc, obj)=>{
                                            if(!acc.some(o => o.f == obj.f)) {
                                              acc.push(obj)
                                            }
                                            return acc;
                                        }, [])
    }                                        
    //console.log(this.conteo)
  }

  fnSoloZebra(){
    this.router.navigate(["s2ValZebraQR"]);
  }

}
